import { Component, Inject, Input, OnInit } from '@angular/core';
import { CampaignManagerItemOfferModel, DATE_OPTIONS, DateOptions } from '@fgb/core';

@Component({
  selector: 'fgb-campaigns-v2-list-item',
  templateUrl: './campaigns-v2-list-item.component.html',
  styleUrls: ['./campaigns-v2-list-item.component.scss'],
})
export class CampaignsV2ListItemComponent implements OnInit {
  @Input() campaignEntitlement: CampaignManagerItemOfferModel;
  isDateExpired: boolean = false;

  constructor(@Inject(DATE_OPTIONS) public dateOption: DateOptions) {}

  ngOnInit(): void {
    if (new Date(this.campaignEntitlement.ExpiryDate) >= new Date()) {
      this.isDateExpired = false;
    } else {
      this.isDateExpired = true;
    }
  }
}
